export const prepareEmpresaDesdeAFIP = async(empresa ={})=>{
    return {
           // ...empresa,
           denominacion: empresa.RazonSocial,
           domicilio: empresa.ObjDomicilioFiscal?.Domicilio,
           codigoPostal: empresa.ObjDomicilioFiscal?.CodigoPostal,
           cuit: empresa.CUIT,
           actividadPrincipal: empresa.DescripcionAFIP,
           idActividadPrincipal: empresa.IdActividadPrincipalAFIP,
           estadoAFIP: empresa.EstadoAFIP
        }
    
}